var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDustbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#EB8181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.038 3.917h13.903M1.746 4.49v9.935h10.518V4.49M5.252 6.834V11.5M8.752 6.834V11.5M4.095 3.344V1.007h5.834v2.337"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDustbin);
export default __webpack_public_path__ + "static/media/icon-dustbin.505d2775124ce6547c913a5c9281e8c6.svg";
export { ForwardRef as ReactComponent };